/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import {
  Button,
  Col,
  Form,
  Modal,
  notification,
  Radio,
  Row,
  Upload,
} from "antd";

import React, { useEffect, useState } from "react";
import { axios, getToken, URL_API, _ } from "../../../../../../utils";
import { beforeUploadImg } from "../../../../../util/helper";
import { Panel, PanelBody, PanelHeader } from "../../../../../util/panel";
import { AiOutlineUpload } from "react-icons/ai";
import TextEditor from "../../../../../../components/TextEditor";
import mwEcosysConstants from "../../../utils/constants/mwEcosysConstants";

import { DivStyles, ImgStyles } from "../../../components/mwStyles";
import useUploadFile from "../../../components/useUploadFile";
import { dummyRequest } from "../../../components/dummyRequest";

function HF_Detail({ history, form, match, ...props }) {
  const [loadValue, setLoadValue] = useState("");

  const [fileListDesktop, setFileListDesktop] = useState([]);
  const [fileListMobile, setFileListMobile] = useState([]);

  const [contentTextEditorDesktop, setContentTextEditorDesktop] = useState();
  const [contentTextEditorMobile, setContentTextEditorMobile] = useState();

  const [fileDelete, setFileDelete] = useState([]);

  let { onUpload } = useUploadFile();

  const handleClickSubmit = () => {
    form.validateFieldsAndScroll((err, values) => {
      if (err) {
        return notification.warning({
          message: "กรุณาตรวจสอบรายการ",
          description: "กรุณากรอกข้อมูลให้ครบถ้วน",
        });
      }

      console.log({ values });

      let formData = new FormData();

      if (fileListDesktop[0]?.file) {
        formData.append("desktop_img", fileListDesktop[0]?.file?.originFileObj);
      }

      if (fileListMobile[0]?.file) {
        formData.append("mobile_img", fileListMobile[0]?.file?.originFileObj);
      }

      formData.append(
        "data",
        JSON.stringify({
          ..._.omit(values, ["desktop_img", "mobile_img"]),
          content: JSON.stringify({
            desktop: contentTextEditorDesktop,
            mobile: contentTextEditorMobile,
          }),
          file_delete: fileDelete,
        })
      );

      console.log(formData);

      Modal.confirm({
        title: "ยืนยัน",
        content: "ต้องการบันทึกข้อมูลหรือไม่",
        okText: "บันทึก",
        cancelText: "ปิด",

        onOk() {
          return new Promise((resolve, reject) => {
            let actionPathUrl;

            if (match.params.id !== "add") {
              actionPathUrl =
                "/manage-website/ecosystem/healthy-food/hf-detail/" +
                match.params.id +
                "/update";
            } else {
              actionPathUrl =
                "/manage-website/ecosystem/healthy-food/hf-detail";
            }
            axios({
              method: "post",
              baseURL: URL_API,
              url: actionPathUrl,
              headers: { Authorization: "Bearer " + getToken() },
              data: formData,
            })
              .then((res) => {
                console.log(res);
                resolve("success");
              })
              .catch((err) => {
                console.log(err);
                reject(
                  err && err.response
                    ? err.response.data.message
                      ? err.response.data.message
                      : err.response.data
                    : err.message
                );
              });
          })
            .then(() => {
              Modal.success({
                title: "สำเร็จ",
                content: "บันทึกเรียบร้อย",
                okText: "ปิด",
                onOk() {
                  history.goBack();
                },
              });
            })
            .catch((reason) => {
              Modal.error({
                title: "ผิดพลาด",
                content: reason,
                okText: "ปิด",
              });
            });
        },
      });
    });
  };

  const handleRemoveDesktop = (e) => {
    setFileListDesktop([]);
    if (e.uid?.toString()?.indexOf("rc-upload") === -1) {
      setFileDelete([...fileDelete, e.uid]);
    }
  };
  const handleRemoveMobile = (e) => {
    setFileListMobile([]);
    if (e.uid?.toString()?.indexOf("rc-upload") === -1) {
      setFileDelete([...fileDelete, e.uid]);
    }
  };

  const handleUploadDesktop = async (e) => {
    let isFile = await onUpload(
      e,
      mwEcosysConstants.hf_detail_page.desktop_img.width,
      mwEcosysConstants.hf_detail_page.desktop_img.height
    );
    if (isFile) {
      setFileListDesktop(isFile);
    }
  };

  const handleUploadMobile = async (e) => {
    let isFile = await onUpload(
      e,
      mwEcosysConstants.hf_detail_page.mobile_img.width,
      mwEcosysConstants.hf_detail_page.mobile_img.height
    );
    if (isFile) {
      setFileListMobile(isFile);
    }
  };

  const loadContent = () => {
    axios({
      method: "get",
      baseURL: URL_API,
      url:
        "/manage-website/ecosystem/healthy-food/hf-detail/" + match.params.id,
      headers: { Authorization: "Bearer " + getToken() },
    })
      .then((res) => {
        console.log(res);
        let data = res.data?.data;
        setLoadValue(data);

        let loadContent = JSON.parse(data.content);
        if (loadContent) {
          setContentTextEditorDesktop(loadContent.desktop);
          setContentTextEditorMobile(loadContent.mobile);
        }

        let { loadDesktopImg, loadMobileImg } = data;

        for (let i in data.files) {
          if (data.files[i].document_type == "34") {
            loadDesktopImg = [
              {
                uid: data.files[i].id,
                status: "done",
                name: data.files[i].file_name,
                url: data.files[i].azure_url,
              },
            ];
            setFileListDesktop(loadDesktopImg);
          } else if (data.files[i].document_type == "35") {
            loadMobileImg = [
              {
                uid: data.files[i].id,
                status: "done",
                name: data.files[i].file_name,
                url: data.files[i].azure_url,
              },
            ];
            setFileListMobile(loadMobileImg);
          }
        }

        form.setFieldsValue({
          ...data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (match.params.id !== "add") {
      loadContent(match.params.id);
    }
  }, [match.params.id]);
  const { getFieldDecorator } = form;
  return (
    <>
      <Panel>
        <PanelHeader>HF Detail</PanelHeader>
        <PanelBody>
          <Row>
            <Row gutter={24}>
              <Col md={12}>
                {fileListDesktop.length != 0 ? (
                  <Row>
                    <div style={DivStyles}>
                      <img
                        src={fileListDesktop[0].url}
                        alt="desktop_img"
                        style={ImgStyles}
                      />
                    </div>
                  </Row>
                ) : (
                  ""
                )}
              </Col>
              <Col md={12}>
                {fileListMobile.length != 0 ? (
                  <div style={DivStyles}>
                    <img
                      src={fileListMobile[0].url}
                      alt="mobile_img"
                      style={ImgStyles}
                    />
                  </div>
                ) : (
                  ""
                )}
              </Col>
            </Row>
            <Row gutter={24} className="mb-2">
              <Col md={12} className="mb-2">
                <Form.Item
                  label={`Desktop = ${mwEcosysConstants.hf_detail_page.desktop_img.width} x ${mwEcosysConstants.hf_detail_page.desktop_img.height} px`}
                >
                  {getFieldDecorator("desktop_img", {
                    initialValue: null,
                  })(
                    <Upload.Dragger
                      accept="image/*"
                      multiple={false}
                      fileList={fileListDesktop}
                      customRequest={dummyRequest}
                      onRemove={handleRemoveDesktop}
                      onChange={handleUploadDesktop}
                      listType="picture"
                    >
                      <AiOutlineUpload className="mr-3" />
                      Upload
                    </Upload.Dragger>
                  )}
                </Form.Item>
              </Col>
              <Col md={12} className="mb-2">
                <Form.Item
                  label={`Mobile = ${mwEcosysConstants.hf_detail_page.mobile_img.width} x ${mwEcosysConstants.hf_detail_page.mobile_img.height} px`}
                >
                  {getFieldDecorator("mobile_img", {
                    initialValue: null,
                  })(
                    <Upload.Dragger
                      accept="image/*"
                      multiple={false}
                      fileList={fileListMobile}
                      customRequest={dummyRequest}
                      beforeUpload={beforeUploadImg}
                      onRemove={handleRemoveMobile}
                      onChange={handleUploadMobile}
                      listType="picture"
                    >
                      <AiOutlineUpload className="mr-3" />
                      Upload
                    </Upload.Dragger>
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col className="mb-2">
                <Row className="mb-3">
                  <p>Content Desktop :</p>
                  <TextEditor
                    authToken={getToken()}
                    value={contentTextEditorDesktop}
                    onInit={(evt, event) => {}}
                    onEditorChange={(e) => {
                      setContentTextEditorDesktop(e);
                    }}
                    onUploadSuccess={(json) => {
                      console.log(json);
                    }}
                    postBody={{ container_name: "web-content" }}
                    urlUpload={`${URL_API}/file/upload`}
                  />
                </Row>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col md={12}>
                <Form.Item label="Content Type ( Desktop ) :">
                  {getFieldDecorator("content_type", {
                    initialValue: "text_left",
                  })(
                    <Radio.Group>
                      <Radio value={"text_left"}>Text Left</Radio>
                      <Radio value={"text_right"}>Text Right</Radio>
                    </Radio.Group>
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row className="mt-3 mb-3">
              <Button
                className="bg-nn border-nn text-white mr-3"
                onClick={() => {
                  history.goBack();
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  handleClickSubmit();
                }}
              >
                {loadValue != (null || "") ? "Update" : "Save"}
              </Button>
            </Row>
          </Row>
        </PanelBody>
      </Panel>
    </>
  );
}
export default Form.create("ecosystem-hf-detail")(HF_Detail);
